<div class="file-input">
	<label [for]="fileInput" class="mb1" *ngIf="label">{{ label }}</label>

	<div class="file-loaded flex items-center" *ngIf="fileName; else loadFile">
		<span class="mr1 text-muted-dark file-name" [title]="fileName">
			{{ fileName }}
		</span>

		<a *ngIf="fileId && enablePreview" target="_blank" href="{{ baseUrl }}/{{ fileId }}?type={{ fileType }}"
			title="Ver archivo">
			<mat-icon>visibility</mat-icon>
		</a>

		<a *ngIf="fileId" (click)="downloadFile()" [download]="fileName" title="Descargar archivo">
			<mat-icon>file_download</mat-icon>
		</a>

		<a title="Quitar archivo" class="remove-file" *ngIf="(!preview) && (!isAdmin)">
			<mat-icon (click)="removeFile()">delete</mat-icon>
		</a>
	</div>

	<ng-template #loadFile>
		<span class="text-muted-dark msg-input" [ngClass]="{ error: errorSize || errorFormat }"
			*ngIf="!preview && !disabled">
			(Tamaño máximo {{ (maxSize / 1000) }}MB / Formatos jpeg, png, Word, Excel, pdf, zip)
		</span>
		<span class="text-muted-dark msg-input" *ngIf="disabled">
			No se puede cargar archivos en este momento.
		</span>
		<button type="button" mat-raised-button (click)="fileInput.click()" *ngIf="!preview && !disabled"
			class='select-button' title='Seleccionar archivo'>
			<mat-icon class="mr1">upload_file</mat-icon>
			<span>Seleccionar archivo</span>
		</button>
	</ng-template>

	<input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file"
		accept="image/png, image/jpeg, .docx, .xlsx, .pdf, .zip" />
</div>